import React, { useState, useEffect, useRef } from 'react';
import { Html5Qrcode } from 'html5-qrcode';
import './QRScannerOfParent.css';

const QRScannerOfParent = ({ onScan }) => {
  const [html5QrCode, setHtml5QrCode] = useState(null);
  const qrReaderRef = useRef(null);
  const isMountedRef = useRef(false); // Theo dõi trạng thái mount

  useEffect(() => {
    if (isMountedRef.current) return; // Ngăn chạy lại nếu đã mount

    isMountedRef.current = true;
    const qrCodeScanner = new Html5Qrcode('qr-reader');
    setHtml5QrCode(qrCodeScanner);

    // Lấy danh sách camera
    Html5Qrcode.getCameras()
      .then((devices) => {
        if (devices && devices.length) {
          const rearCamera = devices.find((device) => {
            const label = device.label.toLowerCase();
            return (
              label.includes('back') ||
              label.includes('sau') ||
              label.includes('rear') ||
              label.includes('main')
            );
          });

          const cameraId = rearCamera ? rearCamera.id : devices[0].id;

          const config = {
            fps: 10,
            qrbox: { width: 250, height: 250 },
            aspectRatio: 1.0,
          };

          // Bắt đầu quét
          qrCodeScanner
            .start(
              cameraId,
              config,
              (decodedText) => {
                if (decodedText) {
                  onScan(decodedText);
                }
              },
              (error) => {
                console.warn(`QR Code scanning error: ${error}`);
              }
            )
            .catch((err) => {
              console.error('Error starting QR scanner: ', err);
            });
        } else {
          console.error('No cameras found on the device.');
        }
      })
      .catch((err) => {
        console.error('Error accessing cameras: ', err);
      });

    // Cleanup khi component unmount
    return () => {
      if (qrCodeScanner) {
        qrCodeScanner
          .stop()
          .then(() => {
            qrCodeScanner.clear();
          })
          .catch((err) => {
            console.error('Error stopping scanner: ', err);
          });
      }
      isMountedRef.current = false;
    };
  }, []); // Dependency array rỗng để chỉ chạy một lần

  return (
    <div className="qr-scanner-lookup">
      <div id="qr-reader" ref={qrReaderRef} className="qr-reader"></div>
      <div className="scanner-overlay">
        <div className="scanner-line"></div>
        <div className="scanner-corners">
          <div className="corner top-left"></div>
          <div className="corner top-right"></div>
          <div className="corner bottom-left"></div>
          <div className="corner bottom-right"></div>
        </div>
      </div>
    </div>
  );
};

export default QRScannerOfParent;